import { Box3, Vector3 } from 'three';

export class Utils3d {

	static makePerformant( obj ) {
		
		const useShadows = false;
		obj.castShadow = useShadows;
		obj.receiveShadow = useShadows;

		// optimizations
		obj.traverse( c => {
			if( c.isScene ) return;
			
			// make it static. WARNING. Do this always AFTER ading the obj into the scene!!
			if( typeof c.matrixAutoUpdate !== 'undefined' ) {
				//update first time
				c.updateMatrix();
				c.updateWorldMatrix( true, true );
				//disable auto update
				c.matrixAutoUpdate = false;
				c.matrixWorldAutoUpdate = false;
			}

			if( typeof c.frustumCulled !== 'undefined' ) {
				// make it appear always. Avoid checking every frame
				c.frustumCulled = false;
			}
 
		} );
	}

	static dispose3d( object, cleanMaterial = true ) {
		if( !object || object.dispose ) return;

		if ( object.geometry ) {
			object.geometry.dispose();
		}
		if ( object.material && cleanMaterial ) {
			if ( Array.isArray( object.material ) ) {
				for ( let i = 0; i < object.material.length; i ++ ) {
					object.material[ i ].dispose();
				}
			} else {
				object.material.dispose();
			}
		}

		object.dispose = true;

		if( object.traverse ) object.traverse ( c => Utils3d.dispose3d( c ) );
	}

	static fitOrthoCamera( obj, camera, container ) {
		// Get the bounding box of the object
		const box = new Box3().setFromObject(obj);
    
		// Get the size of the bounding box (dimensions of the object)
		const size = new Vector3(); box.getSize( size );
		const center = new Vector3(); box.getCenter( center );
		
		// Compute the aspect ratio of the screen
		const width = container && container.offsetWidth ? container.offsetWidth : window.innerWidth;
		const height = container && container.offsetHeight ? container.offsetHeight : window.innerHeight;
		const aspect = width / height;
	
		// Compute the maximum dimension of the object
		const maxSize = Math.max( size.x, size.y, size.z );
		
		// Set the distance the camera needs to be from the object (in orthographic this changes zoom)
		const distance = maxSize * 1.5;
	
		// Update the orthographic camera's frustum to fit the object
		camera.left = (-distance * aspect) / 2;
		camera.right = (distance * aspect) / 2;
		camera.top = distance / 2;
		camera.bottom = -distance / 2;
	
		// Make sure the near and far planes are set to cover the whole object
		camera.near = -distance;
		camera.far = distance * 2;
	
		// Update the camera projection matrix
		camera.updateProjectionMatrix();
	}

	static getRandomHexColor() {
		// Generate a random integer between 0 and 16777215 (decimal for #FFFFFF)
		const randomColor = Math.floor(Math.random() * 16777215);
		
		// Convert the integer to a hexadecimal string and pad with leading zeros if necessary
		const hexColor = '#' + randomColor.toString(16).padStart(6, '0');
		
		//convert to number
		return parseInt( hexColor.replace('#', '0x') );
	}
}